import axios from 'axios';
import { apiUrl } from '~/config';

const httpRequest = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

// Request interceptor
httpRequest.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Response interceptor
httpRequest.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (axios.isAxiosError(error)) {
            const { response } = error;
            return Promise.reject({
                success: false,
                message:
                    response?.data?.message || 'An unexpected error occurred.',
                status: response?.status || null,
            });
        }
        return Promise.reject({
            success: false,
            message: 'An unexpected error occurred',
        });
    },
);

export default httpRequest;
